import Admin__OrganizationProfile__SchemasController from './schemas.js';

Skylark.App.Controllers.register({Admin__OrganizationProfile__SchemasController});
